const additionalSounds = [
    {
        src: "sounds/rocketwav.mp3",
        id: "endSpace",
    },
];
export default additionalSounds;
